import BaseTypeController from "vamos/cockpit/base/controller/BaseTypeController";
import JSONModel from "sap/ui/model/json/JSONModel";
import Dialog from "sap/m/Dialog";
import V4Context from "sap/ui/model/odata/v4/Context";
import DialogService from "vamos/cockpit/base/services/DialogService";
import ServerConfigurationHandler, { ServerConfigurationDto } from "vamos/cockpit/data/supplier/handler/ServerConfigurationHandler";
import { SupplierServerConfigurationDto } from "vamos/cockpit/model/api/vamos.private.api.types";
import { Supplier } from "vamos/cockpit/model/odata/VamosModel";
import { Button$PressEvent } from "sap/m/Button";
import BaseController from "vamos/cockpit/base/controller/type/BaseController";
import JsonUtil from "vamos/cockpit/base/util/JsonUtil";
import ValidationUtil from "vamos/cockpit/base/util/ValidationUtil";
import { showSuccess } from "vamos/cockpit/base/handler/MessageToastHandler";

/**
 * @namespace vamos.cockpit.data.supplier.controller
 * */
export default class EditSupplierDialogController extends BaseController {
    private dialog: Dialog;
    private _oDialogModel: JSONModel;
    private context: V4Context;
    private dialogService: DialogService;
    private serverConfigurationHandler: ServerConfigurationHandler;
    private supplier: Supplier;

    private saveCallBack: () => void;

    onInit(): void {
        super.onInit();
        this.serverConfigurationHandler = new ServerConfigurationHandler();
        this.dialog = this.getView().byId("supplierEditDialog") as Dialog;
        this._oDialogModel = new JSONModel({});
        this.getView().setModel(this._oDialogModel, "supplierDialog");

    }

    public async openDialog(supplierContext: V4Context,serverConfiguration: ServerConfigurationDto, saveCallBack: () => void): Promise<void> {
        if(!supplierContext) {
            return;
        }
        this.context = supplierContext;
        this.setSupplierData(supplierContext.getObject() as Supplier);

        if(!serverConfiguration){
            serverConfiguration =  await this.serverConfigurationHandler.loadServerConfiguration(this.supplier.Guid);
        }
        this.viewModel.setProperty("/bmecat", serverConfiguration.bmecat);
        this.viewModel.setProperty("/opentrans", serverConfiguration.opentrans);



        this.saveCallBack = saveCallBack;

        this.dialog.open();
    }
    async onSaveEdit():Promise<void> {
        if(ValidationUtil.hasEmptyRequiredFields(this.dialog)){
            return;
        }

        JsonUtil.json2OData(this.context, this.getSupplierData(), "changes");
        await this.submitBatch(this.context.getUpdateGroupId());
        const bmecatConfig = this.viewModel.getProperty("/bmecat") as SupplierServerConfigurationDto;
        const openTransConfig = this.viewModel.getProperty("/opentrans") as SupplierServerConfigurationDto;
        await this.serverConfigurationHandler.updateServerConfigurations(this.supplier.Guid, bmecatConfig, openTransConfig);
        this.saveCallBack();
        this.onClosePopup();
        showSuccess(this.getText("EntrySaved"));
    }

    public onClosePopup(): void {
        this.dialog.close();
    }
    private getSupplierData():Supplier{
        return this._oDialogModel.getProperty("/") as Supplier;
    }
    public setSupplierData(supplier: Supplier) {
        this.supplier = supplier;
        this._oDialogModel.setProperty("/", supplier);

    }





}